// @flow
import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import { connect } from 'react-redux';

import { Wrapper, svgStyle } from './style';

import ChevronOuvre from '../../assets/images/chevron_ouvre.svg';
import IconAz from '../../assets/images/pic-az.svg';
import IconNum from '../../assets/images/pic-09.svg';
import Checkbox from '../Checkbox';
import Radio from '../Radio';

import { setFacetState } from '../../actions/ui';

import type { Select } from '../../types/Select';
import { FormattedMessage } from 'react-intl';
import SearchAPI from '../../library/SearchAPI';
import moment from 'moment';

type SelectFacet = {
  ...Select,
  id: string,
  facet: string
};

type Props = {
  title: string,
  items: Array<any>,
  test: Array<any>,
  onSelect: SelectFacet => void,
  facet: string,
  checkedItems: Array<SelectFacet>,
  canBeSort?: boolean,
  facetState: boolean,
  setFacetState: (string, boolean) => void
};

type State = {
  collapse: boolean,
  slice: number,
  items: Array<any>,
  sort: string,
  targetSort: string
};

const sortLabel = (items, sort) => {
  return items.sort((a, b) => {
    const compare = a.label.localeCompare(b.label);
    return sort === 'asc' ? compare : compare * -1;
  });
};

const sortValue = (items, sort) => {
  return items.sort((a, b) => {
    if (a.value > b.value) return sort === 'asc' ? 1 : -1;
    if (a.value < b.value) return sort === 'asc' ? -1 : 1;
    return 0;
  });
};

class ComboFilter extends Component<Props, State> {
  minDisplay: number;
  maxDisplay: number;

  constructor(props: Props) {
    super(props);

    this.minDisplay = props.items.length <= 15 ? props.items.length : 5;
    this.maxDisplay = 99;

    this.state = {
      collapse: false,
      slice: this.minDisplay,
      sort: 'desc',
      targetSort: 'value',
      items: props.items
    };
  }

  static getDerivedStateFromProps(props: Props, state: State) {
    return {
      ...state,
      items: props.items,
      collapse: !props.facetState
    };
  }

  thousandsDisplay = number => {
    const { lang } = this.props;
    return new Intl.NumberFormat((lang ? lang : 'fr') + '-FR').format(number);
  };

  handleClick = (option: SelectFacet) => (): void => {
    const { onSelect, facet } = this.props;

    onSelect({ ...option, facet: option.facet || facet });
  };

  handleRadioChange = (option: SelectFacet) => (): void => {
    const { onSelect, facet } = this.props;
    onSelect({ ...option, facet: option.facet || facet });
  };

  handleCollapse = (): void => {
    this.setState({ slice: this.minDisplay });
    this.props.setFacetState(this.props.facet, this.state.collapse);
  };

  seeMore = (value: number) => (): void => this.setState({ slice: value });

  handleSortLabel = () => {
    const { items, sort } = this.state;

    const newSort = sort === 'asc' ? 'desc' : 'asc';

    const newItems = sortLabel(items, newSort);

    this.setState({ items: newItems, sort: newSort, targetSort: 'label' });
  };

  handleSortValue = () => {
    const { items, sort } = this.state;

    const newSort = sort === 'asc' ? 'desc' : 'asc';

    const newItems = sortValue(items, newSort);

    this.setState({ items: newItems, sort: newSort, targetSort: 'value' });
  };

  render() {
    const { collapse, slice, items, targetSort } = this.state;
    const { checkedItems, title, canBeSort = false, facet } = this.props;

    const itemsSorted = items.sort((a, b) => {
      if (checkedItems.find(l => l.id === a.id) !== undefined) return -1;
      if (checkedItems.find(l => l.id === b.id) !== undefined) return 1;
      return 0;
    });

    let seeMoreOf = '';
    let seeLessOf = '';
    switch (facet) {
      case 'author':
        seeMoreOf = 'comboFilter.show_more_authors';
        seeLessOf = 'comboFilter.show_less_authors';
        break;
      case 'journalsPublications':
        seeMoreOf = 'comboFilter.show_more_journals';
        seeLessOf = 'comboFilter.show_less_journals';
        break;
      case 'booksPublications':
        seeMoreOf = 'comboFilter.show_more_books';
        seeLessOf = 'comboFilter.show_less_books';
        break;
      case 'hypothesesPublications':
        seeMoreOf = 'comboFilter.show_more_blogs';
        seeLessOf = 'comboFilter.show_less_blogs';
        break;
      case 'translations':
        seeMoreOf = 'comboFilter.show_more_languages';
        seeLessOf = 'comboFilter.show_less_languages';
        break;

      default:
        break;
    }

    return (
      <Wrapper>
        <div className="filter-header" onClick={this.handleCollapse}>
          <div className="filter-title">{title}</div>
          <div
            className="filter-icon"
            style={{ transform: collapse ? 'rotate(0deg)' : 'rotate(180deg)' }}
          >
            <ReactSVG svgStyle={svgStyle} src={ChevronOuvre} />
          </div>
        </div>
        <div
          className="filter-content-container"
          style={{ maxHeight: collapse ? '0' : `9999px` }}
        >
          <div
            className="filter-content"
            style={{
              maxHeight: collapse
                ? '0'
                : `${(slice > 5 ? 15 : 5) * 32 + (canBeSort ? 56 : 0)}px`,
              overflowY: slice === this.minDisplay ? 'hidden' : 'scroll'
            }}
          >
            {canBeSort && (
              <div className="filter-sort">
                <div
                  className={`filter-sort-icon filter-sort-az ${
                    targetSort === 'label' ? 'filter-sort-icon--selected' : ''
                  }`}
                  onClick={this.handleSortLabel}
                >
                  <ReactSVG svgStyle={{ width: 40 }} src={IconAz} />
                </div>
                <div
                  className={`filter-sort-icon filter-sort-09 ${
                    targetSort === 'value' ? 'filter-sort-icon--selected' : ''
                  }`}
                  onClick={this.handleSortValue}
                >
                  <ReactSVG svgStyle={svgStyle} src={IconNum} />
                </div>
              </div>
            )}
            {facet === 'access' ? (
              itemsSorted
                .slice(0, slice === this.minDisplay ? slice : 99999)
                .map((item) => {
                  return (
                    <div key={item.id} className="filter-item filter-item--radio">
                      <Radio
                        label={item.label}
                        name="access-or-subscribers"
                        value={item.id}
                        checked={checkedItems.some((l) => l.id === item.id)}
                        onChange={this.handleRadioChange(item)}
                      />
                      <div className="number">
                        {item.id !== 'all-access' ? (item.value === 0 ? '' : this.thousandsDisplay(item.value)) : ''}
                      </div>
                    </div>
                  );
                })
            ) : itemsSorted
              .slice(0, slice === this.minDisplay ? slice : 99999)
              .map(item => {
                return (
                  <div key={item.id} className="filter-item">
                    <Checkbox
                      className="label"
                      label={item.label}
                      value={
                        checkedItems.find(l => l.id === item.id) !== undefined
                      }
                      onClick={this.handleClick(item)}
                    />
                    <div className="number">
                      {item.value === 0 ? '' : this.thousandsDisplay(item.value)}
                    </div>
                  </div>
                );
              })}
            {this.props.test &&
              this.props.test.length > 0 && (
                <React.Fragment>
                  {this.props.test
                    .slice(0, slice === this.minDisplay ? slice : 99999)
                    .map(item => {
                      return (
                        <div key={item.id} className="filter-item">
                          <Checkbox
                            className="label"
                            label={item.label}
                            value={
                              checkedItems.find(l => l.id === item.id) !==
                              undefined
                            }
                            onClick={this.handleClick(item)}
                          />
                          <div className="number">
                            {item.value === 0 ? '' : this.thousandsDisplay(item.value)}
                          </div>
                        </div>
                      );
                    })}
                </React.Fragment>
              )}
          </div>
          {items.length > this.minDisplay &&
            slice === this.minDisplay && (
              <div
                className="filter-see-more"
                onClick={this.seeMore(this.maxDisplay)}
              >
                {seeMoreOf && <FormattedMessage id={seeMoreOf} />}
              </div>
            )}
          {items.length > this.minDisplay &&
            slice !== this.minDisplay && (
              <div
                className="filter-see-more"
                onClick={this.seeMore(this.minDisplay)}
              >
                {seeLessOf && <FormattedMessage id={seeLessOf} />}
              </div>
            )}
        </div>
      </Wrapper>
    );
  }
}

const mapStateToProps = ({ ui: { facetState } }, props) => ({
  facetState: facetState[props.facet]
});

const mapDispatchToProps = dispatch => {
  return {
    setFacetState: (facet, value) => dispatch(setFacetState(facet, value))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ComboFilter);



// WEBPACK FOOTER //
// ./src/components/ComboFilter/index.js